const getFullAddress = (address, community = true) => `${address.street} ${address.buildingNumber}${address.localNumber ? `/${address.localNumber}` : ''}${community ? `, ${address.community || address.city}` : ''}`;

export { getFullAddress };
